import React from "react"
import { graphql } from "gatsby"

import AlternatingList from "../components/alternatingList"
import EventTitle from "../components/eventTitle"
import SpeakerName from "../components/speakerName"
import SpeakerCard from "../components/speakerCard"

import style from "../components/alternatingList.module.css"

const Speakers = ({ data }) => (
	<AlternatingList
		type="Speakers"
		meta={{
			title: "Speakers",
			description: "Check out Accento's speaker lineup!",
			keywords: `Java speaker Karlsruhe`,
			path: "/speakers",
		}}
		snippetId="speakers-intro"
	>
		{generateSpeakers(data.speakers.edges)}
	</AlternatingList>
)

function generateSpeakers(speakers) {
	if (!speakers || speakers.length === 0) return <span />
	return speakers.map(({ node }) => generateSpeaker(node))
}

function generateSpeaker(speaker) {
	return (
		<div className={style.container}>
			<SpeakerCard
				speakerSlug={speaker.frontmatter.slug}
				size="small"
				linkImage
				className={style.image}
			/>
			<div className={style.event}>
				<h2 className={style.title}>
					<SpeakerName speaker={speaker} linkName />
				</h2>
				<p className={style.teaser}>{speaker.frontmatter.bio}</p>
				{talkList(speaker.frontmatter.talks)}
				{trainingList(speaker.frontmatter.trainings)}
			</div>
		</div>
	)
}

function talkList(talks) {
	return eventList("Talk", "Talks", talks)
}

function trainingList(trainings) {
	return eventList("Training", "Trainings", trainings)
}

function eventList(typeSingular, typePlural, events) {
	if (!events || events.length === 0) return

	const type = events.length === 1 ? typeSingular : typePlural
	return (
		<p className={style.teaser}>
			<span style={{ fontWeight: "bold" }}>{type}: </span>
			{list(events)}
		</p>
	)
}

function list(events) {
	return events.map((event, index) => (
		<span>
			<EventTitle event={event} linkTitle />
			{index < events.length - 1 && <span>, </span>}
		</span>
	))
}

export const query = graphql`
	query {
		speakers: allMarkdownRemark(
			sort: { fields: frontmatter___priority, order: ASC }
			filter: { fields: { collection: { eq: "speakers" } } }
		) {
			edges {
				node {
					fields {
						path
					}
					frontmatter {
						name
						slug
						bio
						talks {
							fields {
								path
							}
							frontmatter {
								title
								language
							}
						}
						trainings {
							fields {
								path
							}
							frontmatter {
								title
								language
							}
						}
					}
				}
			}
		}
	}
`

export default Speakers
